import styled from 'styled-components';
import { Media } from '../../../../styles/media';

const { tabletUp } = Media;

export const Container = styled.div`
  max-width: 620px;
  display: flex;
  flex-wrap: wrap;

  > a {
    margin-right: 30px;
  }
`;

export const FooterMenuContainer = styled.div`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;

  ${tabletUp`
    justify-content: center;
  `};

  > li {
    padding-right: 20px;
    margin-right: 20px;
    a {
      font-weight: 400;
    }
  }

  > li:last-of-type {
    border: none;
  }
`;
